export const IMAGES = {
  hero: "/images/hero-group.png",
  watermelon: "/images/watermelon-mint.png",
  bottles: "/images/cleanse-lineup.png",
  pineapple: "/images/pineapple-cayenne.png",
  lemonGinger: "/images/lemon-ginger.png",
  celery: "/images/celery-juice.png",
  orangeCarrot: "/images/orange-carrot.png",
  apple: "/images/apple-cinnamon.png",
  goldenBeet: "/images/golden-beet.png",
  beetRoot: "/images/beet-root.png",
  pineappleCucumber: "/images/pineapple-cucumber.png",
  cucumberMint: "/images/cucumber-mint.png",
  acv: "/images/acv-shot.png",
  beetShot: "/images/beetroot-shot.png",
  botanical: "https://images.unsplash.com/photo-1514936477380-5ea603b9a1ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxmcmVzaCUyMGZydWl0JTIwYm90YW5pY2FsJTIwbGVhZnklMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4NTQ2NjQxM3ww&ixlib=rb-4.1.0&q=85",
  lifestyle: "/images/kind-words.png",
};

export const PHONE = "242-818-1530";
export const PHONE_LINK = "tel:+12428181530";
export const EMAIL = "kimeishw@gmail.com";
export const INSTAGRAM = "@mainsqueeze_bahamas";
export const INSTAGRAM_LINK = "https://instagram.com/mainsqueeze_bahamas";
export const waLink = (msg) => `https://wa.me/12428181530?text=${encodeURIComponent(msg)}`;

export const JUICES = [
  {
    id: "watermelon-mint",
    name: "Watermelon Mint",
    kind: "Signature Juice",
    tagline: "Hydrate. Refresh. Recharge.",
    ingredients: ["Fresh watermelon", "Mint", "Lemon", "Ginger"],
    benefit:
      "Naturally high in water and made with vitamin-C-rich ingredients — cool mint and a gingery finish make it the most refreshing pour on the menu.",
    color: "#FF5A36",
    price: "8oz $8 · 12oz $11",
    image: IMAGES.watermelon,
  },
  {
    id: "apple-cinnamon",
    name: "Apple Cinnamon",
    kind: "Cold-Pressed Juice",
    tagline: "Crisp. Classic. Cozy.",
    ingredients: ["Fresh apples", "Cinnamon (optional)", "Lemon"],
    benefit:
      "Orchard-sweet with an optional warm cinnamon kick. Apples bring quercetin antioxidants and gut-friendly pectin for easy digestion.",
    color: "#C7402D",
    price: "8oz $8 · 12oz $11",
    image: IMAGES.apple,
  },
  {
    id: "golden-beet",
    name: "Golden Beet",
    kind: "Cold-Pressed Juice",
    tagline: "Liquid sunshine.",
    ingredients: ["Gala Apple", "Orange", "Turmeric", "Lemon", "Ginger", "Carrot"],
    benefit:
      "Sweeter and gentler than red beets — rich in folate and potassium for heart health and steady, earthy energy.",
    color: "#E8A33D",
    price: "8oz $8 · 12oz $11",
    image: IMAGES.goldenBeet,
  },
  {
    id: "beet-root",
    name: "Beet Root",
    kind: "Cold-Pressed Juice",
    tagline: "Deep root power.",
    ingredients: ["Purple Beet", "Orange", "Carrot", "Lemon", "Turmeric", "Gala Apple"],
    benefit:
      "Deep, earthy and vibrant ruby-red — made with fresh beets and naturally occurring antioxidants. A flavorful addition to your routine.",
    color: "#A0183B",
    price: "8oz $8 · 12oz $11",
    image: IMAGES.beetRoot,
  },
  {
    id: "pineapple-cucumber",
    name: "Pineapple Cucumber",
    kind: "Cold-Pressed Juice",
    tagline: "Cool tropical crush.",
    ingredients: ["Pineapple", "Cucumber", "Lime", "Mint"],
    benefit:
      "Bromelain from pineapple meets ultra-hydrating cucumber — a light tropical blend that aids digestion and de-bloats.",
    color: "#7A9A3B",
    price: "8oz $9 · 12oz $12",
    image: IMAGES.pineappleCucumber,
  },
  {
    id: "cucumber-mint",
    name: "Cucumber Mint",
    kind: "Cold-Pressed Juice",
    tagline: "Spa day in a bottle.",
    ingredients: ["Cucumber", "Mint", "Lime", "Green apple"],
    benefit:
      "Cooling, ultra-hydrating and gentle on the stomach — silica and vitamin K love your skin from the inside out.",
    color: "#4E7C43",
    price: "8oz $8 · 12oz $11",
    image: IMAGES.cucumberMint,
  },
  {
    id: "celery-juice",
    name: "Celery Juice",
    kind: "Green Juice",
    tagline: "The green reset.",
    ingredients: ["Celery", "Cucumber", "Lemon", "Ginger", "Gala Apple"],
    benefit:
      "Crisp, green and ultra-refreshing — a light, cooling blend made with fresh produce that's easy to love every day.",
    color: "#2F4822",
    price: "8oz $8 · 12oz $11",
    image: IMAGES.celery,
  },
  {
    id: "orange-carrot",
    name: "Orange Carrot",
    kind: "Cold-Pressed Juice",
    tagline: "Sunshine in a glass.",
    ingredients: ["Carrot", "Orange", "Lemon", "Ginger", "Gala Apple", "Turmeric"],
    benefit:
      "Carotenoids for eyes and skin, natural fruit sugars for steady energy and ginger for a happy, settled gut.",
    color: "#F4661F",
    price: "8oz $8 · 12oz $11",
    image: IMAGES.orangeCarrot,
  },
];

export const SHOTS = [
  {
    id: "pineapple-cayenne",
    name: "Pineapple Cayenne",
    kind: "Wellness Shot",
    tagline: "Small bottle. Big fire.",
    ingredients: ["Pineapple", "Cayenne", "Lemon", "Ginger"],
    benefit:
      "Bright pineapple with a fiery cayenne kick and a ginger-forward finish — made with vitamin-C-rich ingredients.",
    color: "#FF9D00",
    price: "$4 · 2oz",
    image: IMAGES.pineapple,
  },
  {
    id: "lemon-ginger",
    name: "Lemon Ginger",
    kind: "Wellness Shot",
    tagline: "Your daily ritual.",
    ingredients: ["Lemon", "Ginger", "Turmeric", "Cayenne"],
    benefit:
      "Bright and citrus-forward with warming ginger and turmeric — a zesty, refreshing way to start the day.",
    color: "#DFA512",
    price: "$4 · 2oz",
    image: IMAGES.lemonGinger,
  },
  {
    id: "acv-shot",
    name: "ACV Shot",
    kind: "Wellness Shot",
    tagline: "The morning kick.",
    ingredients: ["Apple cider vinegar", "Lemon", "Honey", "Cayenne"],
    benefit:
      "Raw apple cider vinegar with the mother, brightened with lemon, a touch of honey and a cayenne kick — a bold start to your morning.",
    color: "#C77B29",
    price: "$4 · 2oz",
    image: IMAGES.acv,
  },
  {
    id: "beetroot-shot",
    name: "Beetroot Shot",
    kind: "Wellness Shot",
    tagline: "Small but mighty.",
    ingredients: ["Beetroot", "Ginger", "Lemon"],
    benefit:
      "Earthy, vibrant beetroot with fresh ginger and lemon — made with fresh produce and naturally occurring antioxidants.",
    color: "#7E1F3D",
    price: "$4 · 2oz",
    image: IMAGES.beetShot,
  },
];

export const CLEANSES = [
  {
    id: "1-day-reset",
    name: "1-Day Reset",
    price: 65,
    tagline: "Perfect for a quick refresh",
    features: ["Supports hydration", "Nutrient-packed refresh", "Great introduction to a juice reset"],
    includes: ["6 × 12oz cold-pressed juices", "Complimentary wellness shot", "Wellness tips & reset guide"],
    span: "lg:col-span-5",
    dark: false,
  },
  {
    id: "2-day-rebalance",
    name: "2-Day Rebalance",
    price: 120,
    tagline: "Deepen your reset experience",
    features: ["Supports hydration", "Supports digestive wellness", "Helps you prioritize fruits and vegetables"],
    includes: ["12 × 12oz cold-pressed juices", "Complimentary wellness shot", "Wellness tips & reset guide"],
    span: "lg:col-span-7",
    dark: false,
  },
  {
    id: "3-day-detox",
    name: "3-Day Full Body Reset",
    price: 175,
    tagline: "Our most loved cleanse",
    features: ["Three days of nutrient-rich juices", "Supports hydration", "A refreshing way to get back on track"],
    includes: ["18 × 12oz cold-pressed juices", "Complimentary wellness shot", "Wellness tips & reset guide"],
    span: "lg:col-span-12",
    dark: true,
    badge: "Most loved",
  },
];

export const TESTIMONIALS = [
  {
    quote: "The 3-day reset completely changed my relationship with food. I felt lighter, clearer and my skin was glowing by day two.",
    name: "Renee M.",
    place: "Nassau",
  },
  {
    quote: "I take the Lemon Ginger shot every single morning now. It's bright, fiery and the freshest start to my day.",
    name: "Devon K.",
    place: "Paradise Island",
  },
  {
    quote: "Watermelon Mint after a beach day is unmatched. You can taste that it's real fruit — nothing from a carton comes close.",
    name: "Alicia B.",
    place: "Cable Beach",
  },
];

export const FAQS = [
  {
    q: "How do I order or reserve my juices?",
    a: "It's simple — call or text 242-818-1530, message us on WhatsApp, DM us on Instagram @mainsqueeze_bahamas, or email kimeishw@gmail.com. Place your order by 3pm for next-day pickup or delivery (local delivery is $5).",
  },
  {
    q: "Do you offer delivery?",
    a: "Yes. Pickup and local delivery options are available. Contact us on WhatsApp when ordering to confirm delivery availability for your location. The local delivery fee is $5.",
  },
  {
    q: "Can I customize my juice or order a bigger size?",
    a: "Absolutely — with advance notice we can customize any blend to your taste or needs. Juices come in 8oz and 12oz bottles, with 1.5L and gallon options available where possible. Just ask when you order.",
  },
  {
    q: "What exactly comes in a juice cleanse?",
    a: "Each cleanse day includes six 12oz cold-pressed juices numbered in drinking order, a complimentary wellness shot, and our wellness tips & reset guide so you know exactly what to drink and when.",
  },
  {
    q: "Do your juices have any added sugar or preservatives?",
    a: "Never. Every bottle is 100% fresh fruit, vegetables and roots — no additives, no preservatives, no added sugar. Just real ingredients, juiced with love.",
  },
  {
    q: "How long do the juices stay fresh?",
    a: "Because nothing is pasteurised or preserved, we recommend drinking your juices within 3 days and keeping them refrigerated at all times. Cleanses are pressed fresh for your start date.",
  },
  {
    q: "I'm new to juice resets — where should I start?",
    a: "Start with the 1-Day Reset. It's gentle, beginner-friendly and gives you a feel for how your body responds. Most people move up to the 2 or 3-day reset from there.",
  },
];
